import * as React from "react"
import Header from "./header-coach"
import Features from "./features"
import OurCommunity from "./our-community"
import OurTechnology from "./our-technology"
import OurApproach from "./our-approach-one-step-funding"
import Succeed from "./succeed"
import PricingPlans from "./pricing-plans"
import PresentationVideo from "./presentation-video"
import Faqs from "./faqs"
import Testimonials from "./testimonials"
import Callout from "./callout"
import Footer from "./footer"
import Privacy from "./privacy"
import ClientTerms from "./client-terms"
import Menu from "./menu-coaching"
import Seo from "./seo"
import profileImg from '../images/josh.jpg'

import CookieConsent, { Cookies } from "react-cookie-consent";
import { useLocation } from "@reach/router"
import { initializeAndTrack } from 'gatsby-plugin-gdpr-cookies'
import { useQueryParam, StringParam } from "use-query-params"

const Layout = ({ landingPage }) => {

  const location = useLocation();

  const BioSection = () => {
    return (
      <section className="mx-auto max-w-[800px] bg-white px-8 py-12 text-black selection:bg-[#16a34a] selection:text-white">
        {/* Top Profile Area */}
        <div className="mb-8 flex flex-col items-center gap-6 sm:flex-row sm:items-center sm:gap-8">

          {/* Profile Image Wrap with Speech Bubble Styling */}
          <div className="relative h-[140px] w-[140px]">
            <div className="relative h-full w-full rounded-full overflow-hidden">
              <img
                src={profileImg}
                alt="Josh Powell"
                className="h-full w-full  object-cover "
              />
            </div>
          </div>

          {/* Name and Title Headers */}
          <div className="flex flex-col  text-center sm:text-left">
            <h2 className="m-0 text-3xl font-bold tracking-tight text-indigo-600">
              Josh Powell
            </h2>
            <p className="m-0 text-xl font-semibold text-black">
              Coach Trader Funding Program
            </p>
          </div>
        </div>

        {/* Main Narrative Text */}
        <div className="flex flex-col gap-6">
          <p className="m-0 font-normal leading-relaxed text-black">
            Josh Powell took his first trade in March 2017, funded by the earnings he scraped together during Army Basic and AIT at Fort Benning. What started as a side pursuit quickly became a relentless daily obsession. By 2018, he began navigating the options market. A move that fundamentally shifted his perspective on how markets actually work.
          </p>
          <p className="m-0 font-normal leading-relaxed text-black">
            Over the last several years, that initial curiosity has morphed into a deep study of market structure and the complexities of the options chain. Driven by the endless curiosity that market structure requires and how the evolution of options continues to reshape the financial landscape, year after year, Josh's primary goal is to take the complexities of the financial markets and shape them into a dynamic, repeatable approach, day after day.
          </p>
          <p className="m-0 font-normal leading-relaxed text-black">
            In 2019, this market curiosity led to the futures space which was where he began to learn, pass, and go on to receive payouts from prop firms like Earn2Trade, Apex, and Take Profit Trader. His market curiosity reached a new level in 2024 when he was selected for and won the Gelber Group’s inaugural Breakout competition - an intensive eight-week mentorship and analysis program led by professional traders.
          </p>
          <p className="m-0 font-normal leading-relaxed text-black">
            Having managed family capital, personal accounts, and multiple prop firm allocations for the last several years, Josh’s methodology now blends macro-level themes with a strict focus on market physics and order flow. Whether he’s trading equity indices, currencies, or the derivatives around them, his goal remains the same: mastering and maintaining everything that goes into consistent, profitable trading.
          </p>
        </div>
      </section>
    );
  };

  const CoachingCurriculum = () => {
    return (
      <div className="bg-black" id="pricing-plans">
      <section className="mx-auto max-w-[800px] px-8 py-12 text-white selection:bg-[#2ecc71] selection:text-black">
        {/* Section Title */}
        <h2 className="mb-8 text-center text-3xl font-bold tracking-wide text-green">
          Coaching Curriculum
        </h2>

        <div className="flex flex-col gap-8">

          {/* Section: Options Specific Curriculum */}
          <div className="1text-3xl">
            <h3 className="mb-4 font-bold text-white">
              Options Specific Curriculum (Contact for further details)
            </h3>
            <ul className="list-disc pl-5 flex flex-col gap-3 text-[#e0e0e0] leading-relaxed">
              <li>
                <strong className="text-white">The Greeks Simplified:</strong> A practical look at Delta, Gamma, Theta, and Vega—understanding how price, time, and volatility actually move your P&L.
              </li>
              <li>
                <strong className="text-white">Volatility & The 0DTE Playbook:</strong> Understanding the basics of Implied Volatility (IV) and how to utilize the emergence of 0DTE (Zero Days to Expiration) options to capture intraday moves and rapid price acceleration.
              </li>
              <li>
                <strong className="text-white">Smart Leverage & Spreads:</strong> How to use Spreads (Verticals, Calendars) to define your risk, lower your costs, and trade big moves with less capital.
              </li>
              <li>
                <strong className="text-white">The Options Playbook:</strong> Integrating options into your existing strategy—using them to hedge losers, protect profits, and generate income in sideways markets.
              </li>
            </ul>
          </div>

          {/* Section: Module 1 */}
          <div>
            <h3 className="mb-4 font-bold text-white uppercase tracking-wider">
              MODULE 1: Principles of Proprietary Trading
            </h3>
            <ul className="list-disc pl-5 flex flex-col gap-3 text-[#e0e0e0] leading-relaxed">
              <li>Understanding the various tradeable asset classes offered at the Trader Funding Program</li>
              <li>Understanding the basic principles of risk and how it differs across each asset class</li>
              <li>
                <strong className="text-white">Prop pitfalls:</strong> Biases, tactical vs rushed profit taking, averaging losers, sizing mistakes
              </li>
              <li>
                <strong className="text-white">Prop advantages:</strong> Access to capital, global markets, and a community of professional traders
              </li>
              <li>Every trader is different, a discussion on how can we best apply your strengths (and manage weak tendencies) to the Trader Funding Program</li>
            </ul>
          </div>

          {/* Section: Module 2 */}
          <div>
            <h3 className="mb-4 font-bold text-white uppercase tracking-wider">
              MODULE 2: Principles of Technical Analysis
            </h3>
            <ul className="list-disc pl-5 flex flex-col gap-3 text-[#e0e0e0] leading-relaxed">
              <li>Understanding candlesticks and charts across various timeframes</li>
              <li>Defining various technical indicators like moving averages, RSI, MACD, and Bollinger Bands</li>
              <li>Defining Fibonacci Retracement</li>
              <li>Defining price discovery and auction theory</li>
              <li>Understanding range, and the dynamics behind supply and demand</li>
              <li>Trading philosophies and the psychology behind technical analysis</li>
              <li>How can we identify then apply the best technical principle for you?</li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 font-bold text-white uppercase tracking-wider">
              MODULE 3: Macro and Fundamental Analysis
            </h3>
            <ul className="list-disc pl-5 flex flex-col gap-3 text-[#e0e0e0] leading-relaxed">
              <li>What moves the markets</li>
              <li>When do they move the markets</li>
              <li>Why do they move the markets</li>
              <li>Key lesson point: Understanding what matters when and not being fooled by randomness</li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 font-bold text-white uppercase tracking-wider">
              MODULE 4: Risk Management
            </h3>
            <ul className="list-disc pl-5 flex flex-col gap-3 text-[#e0e0e0] leading-relaxed">
              <li>Deep dive into applying an asymmetrical risk mindset and practice to your prop trading</li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 font-bold text-white uppercase tracking-wider">
              MODULE 5: Review and Trade Plan
            </h3>
            <ul className="list-disc pl-5 flex flex-col gap-3 text-[#e0e0e0] leading-relaxed">
              <li>Final thoughts on personal trading strengths and weakness</li>
              <li>Applying the lessons learned to an actionable trading strategy</li>
            </ul>
          </div>

        </div>
      </section>
      </div>
    );
  };

  const VideoGallery = () => {
    const videoIds = [
      'uURzocjjcdw',
      'TqO2n31VlkE',
      'THonzDHud6E',
      'Jx4ntzPWb6o',
    ];

    return (
      <section className="bg-[#45EABC] px-6 py-16 font-sans text-black selection:bg-black selection:text-[#45EABC]">
        <div className="mx-auto max-w-[1200px]">

          {/* Section Header */}
          <div className="mb-12 text-center">
            <h2 className="m-0 text-3xl font-extrabold tracking-tight sm:text-4xl">
              Prop Trading Insights
            </h2>
            <p className="mt-3 text-xl font-medium">
              Discover key insights into prop trading with Josh Powell. These videos cover the basics of proprietary trading, common mistakes, the trader development process, and essential risk management strategies to help traders build long-term consistency and success.
            </p>
          </div>

          {/* Bulletproof Video Grid Layout */}
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:gap-8 w-full">
            {videoIds.map((id) => (
              <div
                key={id}
                className="w-full rounded-xl overflow-hidden shadow-lg bg-black transition-transform duration-300 hover:scale-[1.01]"
              >
                {/* The 16:9 Aspect Ratio Container Container */}
                <div className="relative w-full h-0 pb-[56.25%]">
                  <iframe
                    className="absolute top-0 left-0 w-full h-full border-0"
                    src={`https://youtube.com/embed/${id}?rel=0`}
                    title={`YouTube video player - ${id}`}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>
    );
  };


  const bookNow = () => {
    return (
      <div className="bg-white" id="book-now">
        <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl font-extrabold text-indigo-600 sm:text-3xl lg:text-3xl">
              Book Now
            </h2>
            <p className="mt-4 text-lg leading-6 text-black">

              <span className="font-bold text-2xl">$85 for a 60-minute session,</span>
              <br/>this is an investment in your trading future
              <br/>
              that you can't afford to miss.
            </p>
          </div>
        </div>

        <div className="relative max-w-7xl mx-auto px-0 lg:px-8 h-full">
          <section className="bg-gray-100 overflow-hidden" id="josh">
            <iframe
              onload="this.style.height=(this.contentWindow.document.body.scrollHeight+20)+'px';"
              src="https://TraderCoach.as.me/?appointmentType=94513288" title="Schedule Appointment" width="100%" height="1000" frameBorder="0"></iframe>
            <script src="https://embed.acuityscheduling.com/js/embed.js" type="text/javascript"></script>
          </section>
        </div>
      </div>
    );
  }

  return (
    <>
      <CookieConsent
        location="bottom"
        cookieName="gatsby-gdpr-google-tagmanager"
        style={{ background: 'rgb(51,51,51)', padding: '15px' }}
        buttonText="Accept"
        buttonStyle={{
          backgroundColor: '#FFF',
          color: '#000',
          fontSize: '13px',
          borderRadius: '5px',
        }}
        enableDeclineButton
        declineButtonText="Decline"
        declineButtonStyle={{
          backgroundColor: '#555',
          color: '#efefef',
          fontSize: '13px',
          borderRadius: '5px',
        }}
        onAccept={() => {
        initializeAndTrack(location)
      }}
      >
      This website uses cookies to enhance the user experience. Your privacy is important to us, and we will never sell your data. <br/><a style={{textDecoration: 'underline'}} href="/privacy">Privacy Policy</a>
      </CookieConsent>

      <Menu />
      {location.pathname.startsWith("/privacy") ? (
        <main>
          <Privacy />
        </main>
        ) : location.pathname.startsWith("/client-terms") ? (
        <main>
          <ClientTerms />
        </main> ) : (
        <>
          <Seo landingPage={landingPage} />
            <Header />
            <Seo landingPage={landingPage} />
            <main>
              {BioSection()}
              {CoachingCurriculum()}
              {VideoGallery()}
              {bookNow()}

            </main >
        </>
      )}
      <Footer />
    </>
  )
}

export default Layout
